import { FC, useMemo } from 'react';
import { Card, ClipboardButton, Flex, sp, Text } from '@gravity-ui/uikit';
import classes from './clipboardTextField.module.css';

type ClipboardTextfieldParams = {
    text: string;
    widthInLines?: number;
};

type InlineStyles = {
    maxHeight?: string;
};

export const ClipboardTextfield: FC<ClipboardTextfieldParams> = ({ text, widthInLines }) => {
    const inlineStyles = useMemo<InlineStyles>(() => {
        const styles: InlineStyles = {};

        if (widthInLines) {
            styles.maxHeight = `${widthInLines * 18}px`;
        }

        return styles;
    }, [widthInLines]);

    return (
        <Card type="container" view="filled" className={sp({ p: 2 })}>
            <Flex gap="3">
                <Text whiteSpace="break-spaces" wordBreak="break-all">
                    <div
                        className={[
                            classes['text-block'],
                            widthInLines ? classes['text-block_one-line'] : '',
                        ].join(' ')}
                        style={inlineStyles}
                    >
                        {text}
                    </div>
                </Text>
                <ClipboardButton size="m" text={text} />
            </Flex>
        </Card>
    );
};
